import React from "react";
import styled from "styled-components";
import Document from "@kiwicom/orbit-components/lib/icons/Document";
import Heading from "@kiwicom/orbit-components/lib/Heading";

import Button from "@kiwicom/orbit-components/lib/Button";

import MenuItem from "./MenuItem";
import Link from "next/link";
import { hasScopeFromToken } from "../../helpers/hasScope";
import getAuthorization from "../../helpers/getAuthorization";
import { LoginScope } from "../../generated/graphql";

const StyledMenu = styled.div`
  background: #fff;
  box-shadow: -5px 0 16px -2px rgba(0, 0, 0, 0.75);
  float: left;
  min-height: 100%;
  text-align: center;
  padding-top: 30px;
  width: 190px;
  position: fixed;
  box-sizing: border-box;
  padding-bottom: 50px;
`;

const StyledMenuSection = styled.div`
  padding: 30px 0;
`;

const StyledLogout = styled.div`
  bottom: 0;
  padding: 10px;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
`;

const Menu = () => {
  const authorization = getAuthorization();

  return (
    <StyledMenu>
      {authorization.token && (
        <>
          <Heading type="title5">Privátní</Heading>
          <StyledMenuSection>
            {/* <MenuItem icon={<BillingDetails />} linkTo="/private/markets">
              Cílové trhy
            </MenuItem> */}
            <MenuItem icon={<Document />} linkTo="/private/contract">
              Distribuční smlouva
            </MenuItem>
            {hasScopeFromToken(authorization.token, LoginScope.Tesla) && (
              <MenuItem icon={<Document />} linkTo="/private/tesla">
                ATRIS smlouva
              </MenuItem>
            )}
            {/* <MenuItem
              icon={<Invoice />}
              href={`https://calculator-private.teslainvest.cz/?token=${token}`}
            >
              Kalkulačka
            </MenuItem> */}
          </StyledMenuSection>
        </>
      )}

      <Heading type="title5">Veřejné</Heading>
      <StyledMenuSection>
        {/*<MenuItem icon={<Document />} href={`https://docs.teslainvest.cz/`}>*/}
        {/*  Smlouva*/}
        {/*</MenuItem>*/}
        {/* <MenuItem
          icon={<Invoice />}
          href={`https://calculator.teslainvest.cz/`}
        >
          Kalkulačka
        </MenuItem> */}
        <MenuItem icon={<Document />} linkTo="/public/contract">
          Smlouva
        </MenuItem>
      </StyledMenuSection>

      {authorization.token && (
        <StyledLogout>
          <Link href="/logout">
            <Button fullWidth>Odhlásit se</Button>
          </Link>
        </StyledLogout>
      )}
    </StyledMenu>
  );
};

export default Menu;
